import React from 'react';
import { useSelector } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import { Redirect } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import ReportRouteSheet from '../ReportRouteSheet';
import Authentication from '../Authentication';

const auth = new Authentication();

export const RouteSheetRoute = () => {
  const login = useSelector(state => state.login);
  const [redirect, setRedirect] = React.useState(!login.loggedIn);
  const loginPath = '/login';

  React.useEffect(() => {
    setRedirect(!login.loggedIn);
  }, [login]);

  return (
    <ToastProvider>
      {redirect && <Redirect to={loginPath} />}
      <ErrorBoundary>
        {[<ReportRouteSheet key={0} auth={auth} />]}
      </ErrorBoundary>
    </ToastProvider>
  );
};